module.exports = __webpack_public_path__ + "assets/monkey.25b70aa968840701ee336686e64f85bb.bin";